import {spac} from 'constants/url';
import useAdd from '../../../components/hooks/useAdd';
import {AddingOptions} from '../../../components/grid-dx/types';

function useAddSpac() {
  const addSpac = useAdd(spac);
  return (addingOptions: AddingOptions) => addSpac(addingOptions);
}

export default useAddSpac;
